import { execAdmin } from '../utils';

interface GetCatalogUploadUrlVariables {
  partnerCode: string;
  filename: string;
}

interface CatalogUploadUrlResult {
  uploadUrl: string;
  awsKey: string;
}

interface GetCatalogUploadUrlResponse {
  getCatalogUploadUrl: CatalogUploadUrlResult;
}

const GET_CATALOG_UPLOAD_URL_QUERY = `
  query getCatalogUploadUrl($partnerCode: String!, $filename: String!) {
    getCatalogUploadUrl(partnerCode: $partnerCode, filename: $filename) {
      uploadUrl
      awsKey
    }
  }
`;

export const getCatalogUploadUrl = async (
  variables: GetCatalogUploadUrlVariables,
): Promise<CatalogUploadUrlResult> => {
  const data = await execAdmin<GetCatalogUploadUrlVariables, GetCatalogUploadUrlResponse>(
    GET_CATALOG_UPLOAD_URL_QUERY,
    { variables },
  );

  return data.getCatalogUploadUrl;
};
